import { apiClient } from "@/lib/api/client";
import { useAuthStore } from "@/lib/auth";
import { useCallback, useEffect } from "react";
import type { SupportedLanguage } from "../config/languages";
import { useDetectedLanguage } from "./useDetectedLanguage";
import { useUpdateLocale } from "./useUpdateLocale";

/**
 * 開発者ショートカットとしてcontrol + command + lで日英をトグルする
 */
const useChangeLanguageByKeyPress = () => {
  const authStore = useAuthStore();
  const { detectedLanguage } = useDetectedLanguage();

  const mutator = useUpdateLocale({
    apiClient: {
      PATCH: (_url: string, options: { body: { locale: SupportedLanguage } }) =>
        apiClient.PATCH("/v2/session/locale" as const, options),
    },
    authStore: {
      isAuthenticated: authStore.isAuthenticated,
      setLocale: authStore.setLocale,
      refreshUserSession: async () => {
        await authStore.refreshUserSession();
      },
    },
  });

  const handleKeyPress = useCallback(
    (e: KeyboardEvent) => {
      if (e.ctrlKey && e.metaKey && e.key === "l") {
        mutator.mutate(detectedLanguage === "en-US" ? "ja-JP" : "en-US");
      }
    },
    [detectedLanguage, mutator],
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);
};

export default useChangeLanguageByKeyPress;
